import { Router } from '@angular/router';

/** Bounce a logged-out visitor to /auth/login, preserving where they were (plus any
 *  extra flags an auth-gated action needs to resume itself on return) as a single
 *  `returnTo` query param. `SignInComponent.redirectAfterAuth()` parses `returnTo`'s
 *  own `path?query` generically, so any extra params land back on the target page
 *  once signed in. */
export function redirectToSignIn(router: Router, extraParams: Record<string, string> = {}): void {
  const qs = new URLSearchParams(extraParams).toString();
  const sep = router.url.includes('?') ? '&' : '?';
  const returnTo = qs ? `${router.url}${sep}${qs}` : router.url;
  router.navigate(['/auth/login'], { queryParams: { returnTo } });
}
